document.addEventListener("turbolinks:load", () => {
  const radioButtons = document.querySelectorAll('input[name="youtube_master_setting[kind]"]');
  const templateSchedule = document.querySelector('.template-schedule');
  var titleField = document.querySelectorAll('.master-setting-channel-title');
  var descField = document.querySelectorAll('.master-setting-channel-description');
  selectedValue = document.querySelector('input[name="youtube_master_setting[kind]"]:checked').value;

  if (selectedValue === 'stream') {
    templateSchedule.style.display = 'none';
    titleField.forEach((field) => {
      field.style.display = 'block';
    });
    descField.forEach((field) => {
      field.style.display = 'block';
    });
  } else if (selectedValue === 'template') {
    templateSchedule.style.display = 'block';
    titleField.forEach((field) => {
      field.style.display = 'none';
    });
    descField.forEach((field) => {
      field.style.display = 'none';
    });
  }

  if (radioButtons) {
    radioButtons.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        titleField = document.querySelectorAll('.master-setting-channel-title');
        descField = document.querySelectorAll('.master-setting-channel-description');
        const value = event.target.value;
        if (value === 'stream') {
          templateSchedule.style.display = 'none';
          titleField.forEach((field) => {
            field.style.display = 'block';
          });
          descField.forEach((field) => {
            field.style.display = 'block';
          });
        } else if (value === 'template') {
          templateSchedule.style.display = 'block';
          titleField.forEach((field) => {
            field.style.display = 'none';
          });
          descField.forEach((field) => {
            field.style.display = 'none';
          });
        }
      });
    });
  }
});
